/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';

Vue.use(Vuex);

// Plugin Vuex Persistance
import { createVuexPersistance } from './vuex-persistance-plugin';

// Global
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Module
import auth from './auth/module-auth';
import user from './user/module-user';
import company from './company/module-company';
import layout from './layout/module-layout';
import taxpaper from './taxpaper/module-taxpaper';
import taxreturn from './taxdec/taxreturn/module-taxreturn';
import taxreturnsubmission from './taxdec/taxreturnsubmission/module-taxreturnsubmission';
import servicetvan from './servicetvan/module-servicetvan';
import dictionary from './dictionary/module-dictionary';
import notification from './notification/module-notification';
import taxregis from './taxdec/taxregis/module-taxregis';
import taxpayerinfo from './taxpayer/module-taxpayerinfo';
import dashboard from './dashboard/module-dashboard';
import common from './common/module-common';
import config from './config/module-config';
import taxreturnregishistory from './taxdec/taxregishistory/module-taxregishistory';
import contactadditional from './contactadditional/module-contactadditional';
import accesslog from './log/module-log';
import licenseinfo from './licenseinfo/module-licenseinfo';
import misaorder from './misaorder/module-misaorder';
import options from './options/module-options';
import statebudget from './statebudget/module-statebudget';
import products from './products/module-products';
import modulesettingnoti from './notisetting/module-settingnoti.js';
import misastore from './misastore/module-misastore.js';
import remotesigning from './remotesigning/module-remotesigning.js';
import agreement from './licenseagreement/module-agreement.js';
import amisconvert from './amisconvert/module-amisconvert';
import mws from './mws/module-mws';

// Init instance of store
const store = new Vuex.Store({
	plugins:
		process.env.NODE_ENV !== 'production'
			? [createLogger(), createVuexPersistance()]
			: [createVuexPersistance()],
	getters,
	mutations,
	state,
	actions,
	modules: {
		auth,
		common,
		company,
		config,
		contactadditional,
		dashboard,
		dictionary,
		layout,
		licenseinfo,
		accesslog,
		misaorder,
		notification,
		servicetvan,
		taxregis,
		taxreturnregishistory,
		taxreturn,
		taxreturnsubmission,
		taxpaper,
		taxpayerinfo,
		user,
		options,
		statebudget,
		products,
		modulesettingnoti,
		misastore,
		remotesigning,
		agreement,
		amisconvert,
		mws
	},
	strict: false
});

export default store;
